module.exports = __webpack_public_path__ + "img/wiki.5e5f1e0b.svg";